var _g, _rect, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    width: "1190.55px",
    height: "841.89px",
    viewBox: "0 0 1190.55 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M816.108,630.063c0,6.236-5.103,11.339-11.339,11.339h-290.91c-6.236,0-11.338-5.103-11.338-11.339 V319.962c0-6.236,5.103-11.338,11.338-11.338h290.91c6.236,0,11.339,5.103,11.339,11.338V630.063z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.569,
    y: 735.724,
    fill: "#006A4E",
    width: 1097.935,
    height: 98.196
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2F",
    d: "M1190.979,113.759c-0.23-0.039-172.746,99.091-213.164,114.174c-37.159,14.672-51.7-4.284-55.176-11.621 c-7.363-7.171-29.168-72.876-29.035-73.001c-0.133,0.125,11.667,1.82,32.603-3.503C952.481,133.127,1190.749-0.083,1190.979,0 V113.759L1190.979,113.759z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#006A4E",
    d: "M709.635,201.195l74.107,185.54l130.892-68.844L801.269,66.642H636.335l-231.67,432.24 c0.179,0.081,113.981-3.502,186.916-58.467C610.035,429.575,662.012,293.029,709.635,201.195L709.635,201.195L709.635,201.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009597",
    d: "M914.634,317.892l-130.892,68.844c-112.01,57.35-218.395,107.664-275.679,123.86 c-151.139,43.529-335.229,69.644-401.37,11.085c-62.189-55.218,81.423-286.412,353.08-337.853 c44.046-9.816,69.758-7.297,69.758-7.012c0-0.285-18.623-79.058-33.115-95.661c-20.257-24.783-40.105-29.882-69.697-26.126 C367.915,58.53,117.77,125.215,19.071,333.623c-55.038,118.413,21.804,243.028,69.591,275.558 c14.567,11.683,161.77,139.833,488.476,11.767C900.808,495.38,1190.749,297.63,1190.979,297.63V165.328 C1190.854,165.162,1063.032,238.408,914.634,317.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006A4E",
    d: "M829.681,507.332c12.104,28.453,46.912,111.206,55.813,135.057c11.614,26.128,40.622,26.128,40.622,26.002 h151.009L964.665,435.322C923.453,458.433,878.03,482.826,829.681,507.332z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCats);
export default __webpack_public_path__ + "static/media/cats.ccff7461.svg";
export { ForwardRef as ReactComponent };